import React, { useEffect } from "react";
import "./styles/Input.css";

const Input = ({
  index,
  type,
  isDisabled,
  minLength,
  maxLength,
  inputRef,
  value,
  placeholder,
  hasError,
  handleInputFocus,
  handleInputValue,
  handlekeyDown,
  handleOnPaste,
  styleObject,
}) => {
  const isValidStyleObject = typeof styleObject === "object";
  useEffect(() => {
    if (index === 0) inputRef.current.focus();
  }, []);


  return (
    <input
      className={`form-control w-full  h-[100px] ${
        hasError ? "form-error" : "form-control-solid"
      }`}
      disabled={isDisabled}
      minLength={minLength}
      maxLength={maxLength}
      ref={inputRef}
      value={value}
      placeholder={placeholder}
      onFocus={handleInputFocus}
      type="text "
      inputMode="numeric"
      onChange={(event) => handleInputValue(event, index)}
      onKeyDown={(event) => handlekeyDown(event, index)}
      onPaste={(event) => handleOnPaste(event, index)}
    />
  );
};

export default Input;
